
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { mapPlanConfigToUI } from "@/components/dashboard/subscription/utils";

export const usePlanConfigs = () => {
  return useQuery({
    queryKey: ['planConfigs'],
    queryFn: async () => {
      console.log(`[${new Date().toISOString()}] [usePlanConfigs] Fetching plan configs from database`);
      
      const { data, error } = await supabase
        .from('plan_configs')
        .select('*')
        .not('plan', 'in', '(trial,custom)')
        .order('monthly_price', { ascending: true });

      if (error) {
        console.error(`[${new Date().toISOString()}] [usePlanConfigs] Error fetching plan configs:`, error);
        throw error;
      }

      console.log(`[${new Date().toISOString()}] [usePlanConfigs] Raw plan configs from database:`, data);
      
      if (!data || data.length === 0) {
        console.warn(`[${new Date().toISOString()}] [usePlanConfigs] No plan configs found in database`);
        return [];
      }
      
      // Log each raw plan config individually
      data.forEach((config, index) => {
        console.log(`[${new Date().toISOString()}] [usePlanConfigs] Raw plan config ${index + 1}:`, JSON.stringify(config, null, 2));
      });
      
      const mappedConfigs = data.map(mapPlanConfigToUI);
      
      // Log each mapped config individually
      mappedConfigs.forEach((config, index) => {
        console.log(`[${new Date().toISOString()}] [usePlanConfigs] Mapped plan config ${index + 1}:`, JSON.stringify(config, null, 2));
        console.log(`[${new Date().toISOString()}] [usePlanConfigs] Plan ${config.name} features:`, config.features);
      });
      
      console.log(`[${new Date().toISOString()}] [usePlanConfigs] All mapped plan configs for UI:`, mappedConfigs);
      
      return mappedConfigs;
    },
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep cached for 10 minutes
  });
};
